import { ActivatedRouteSnapshot, CanActivateChildFn, Router } from '@angular/router';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';

import { map, Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';

import { profileOrUndefinedIfNotLoggedIn } from '@fcom/core/selectors';
import { Profile } from '@fcom/core-api/login';
import { AppState } from '@fcom/core';
import { isCorporateAdminOrTravelBooker } from '@fcom/common/login/services/utils';

import { denyAndRedirectToCorporateHome } from './deny-and-redirect-to-corporate-home';

export const corporateAdminOrTravelBookerGuard: CanActivateChildFn = (
  route: ActivatedRouteSnapshot
): Observable<boolean> => {
  const platform = inject(PLATFORM_ID);
  const store$ = inject(Store<AppState>);
  const router = inject(Router);

  if (isPlatformServer(platform)) {
    return of(true);
  }
  return store$.pipe(
    profileOrUndefinedIfNotLoggedIn(),
    map((p: Profile): boolean => {
      if (!isCorporateAdminOrTravelBooker(p)) {
        return denyAndRedirectToCorporateHome(router, route);
      }
      return true;
    })
  );
};
